<template lang="pug">
  .curriculum-top-view
    p(class="curriculum-title") {{ curriculum.title }}

    p(class="curriculum-training-hours") {{ `練習時間： ${curriculum.trainingHours}時間` }}

    video-thumbnail-detail(
      :src="curriculum.video.thumbnailUrl"
      :videoUrl="curriculum.video.videoUrl"
      @click="$emit('click', $event)"
    )

    multiline-text-view(
      :text="curriculum.description"
      class="multiline-text-view"
    )
</template>

<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}

.curriculum-title {
  @extend %headline-detail-text;
}

.curriculum-training-hours {
  @extend %footnote-text;
  margin: 8px 0 24px;
}

.multiline-text-view {
  margin: 16px 0 0;
  padding: 0;
}
</style>

<script>
import VideoThumbnailDetail from '@/components/atoms/VideoThumbnailDetail'
import MultilineTextView from '@/components/molecules/MultilineTextView'

export default {
  props: {
    curriculum: { type: Object, required: true },
  },
  components: { VideoThumbnailDetail, MultilineTextView },
}
</script>
